<template>
    <div>
        <p>
            <strong>În temeiul și pentru efectele art. 1341 și 1342 din Codul civil italian</strong>, Utilizatorul declară în mod expres că a citit, a
            înțeles și a acceptat următoarele clauze:
        </p>
        <p>Art. 1 Definiții, lit. l), „Fleequid”, entitate juridică și regimul fiscal aplicabil;</p>
        <p>Art. 2.3 Comisioane datorate atât de Vânzător, cât și de Cumpărător;</p>
        <p>Art. 2.4 Modalități de licitație și determinarea prețului de adjudecare;</p>
        <p>Art. 2.5 Procesul de revânzare;</p>
        <p>
            Art. 3 Aprobarea eventualelor condiții generale propuse de utilizatori, modificarea unilaterală a Condițiilor Generale de către Fleequid
            și ierarhia documentelor contractuale;
        </p>
        <p>Art. 4.5 Limitări privind utilizarea Marketplace-ului;</p>
        <p>Art. 4.6 Măsuri adoptate de Fleequid în caz de încălcare a regulilor de utilizare;</p>
        <p>Art. 4.7 Reziliere;</p>
        <p>Art. 4.8 Penalitate;</p>
        <p>Art. 4.10 Exonerare de răspundere privind funcționarea Marketplace-ului;</p>
        <p>Art. 4.11 Ștergerea profilului Utilizatorului și exercitarea dreptului de retragere;</p>
        <p>
            Art. 6 referitor la: clauză rezolutorie expresă, exclusivitate de vânzare, condițiile și durata acestei exclusivități, posibilitatea unei
            adjudecări ulterioare, limitări ale vânzării, posibilitatea anulării sau rezilierii vânzării în caz de întârziere sau neplată de către
            Cumpărător, renunțarea Vânzătorului la pretenții sau excepții, clauză de despăgubire, dosar tehnic, penalități în sarcina Vânzătorului;
        </p>
        <p>
            Art. 7 Invitație la ofertare (invitatio ad offerendum), durata ofertei irevocabile de cumpărare, condiții speciale de licitație, preț de
            rezervă;
        </p>
        <p>Art. 8.4 Tratamentul depozitului de garanție;</p>
        <p>Art. 9.3 Plata prețului vehiculului;</p>
        <p>
            Art. 9.4 Facturare anticipată la cererea Fleequid, condiție suspensivă a plății subordonată încasării integrale de la Cumpărător
            (pay-when-paid), obligația de emitere a notei de credit în caz de neplată sau anulare a vânzării, drept de compensare, penalități zilnice
            pentru întârzieri sau omisiuni și renunțarea Vânzătorului la pretenții sau excepții față de Fleequid;
        </p>
        <p>Art. 9.5 Penalitate;</p>
        <p>Art. 9.7 și 9.8 Termene de notificare a viciilor și defectelor;</p>
        <p>Art. 9.10 Clauză rezolutorie expresă și penalitate;</p>
        <p>
            Art. 10 Condiții de plată, reziliere, penalități, condiții care reglementează revânzarea și exonerarea de răspundere, kilometraj, termene
            de verificare a defectelor la livrare;
        </p>
        <p>
            Art. 11 Excluderea garanției și exonerarea de răspundere a Fleequid, transferul riscului, clauză rezolutorie expresă, penalități, dreptul
            de anulare a vânzării, excluderea viciilor ascunse, limite de răspundere bazate pe kilometraj și vechimea vehiculului;
        </p>
        <p>
            Art. 13 Reclamații, propuneri de soluționare a reclamațiilor, soluționarea reclamației de către Fleequid prin anularea vânzării, vicii
            ascunse, exonerare de răspundere, clauză „văzut și acceptat”, penalități;
        </p>
        <p>Art. 14 Clauză de legătură;</p>
        <p>Art. 15 Legea aplicabilă, limba și instanța competentă.</p>
    </div>
</template>
